import { GenericAbortSignal } from 'axios';
import { AutoCompleteDataModel, AutoCompleteSuggestions } from 'components/MprcAutoComplete';
import { IAutoCompleteProps, MprcAutoComplete } from 'components/MprcAutoComplete/AutoComplete';
import { useCoreApi } from 'providers/CoreApiProvider';
import React from 'react';
import { useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////

interface IProps extends Omit<IAutoCompleteProps, 'onGetSuggestions'> {}

////////////////////////////////////////////////////////////////////////////

export const UsageAutoComplete: React.FC<IProps> = ({ label, onChange, ...props }) => {

    const api = useCoreApi();
    const { t } = useTranslation("core");

    ////////////////////////////////////////////////////////////////////////////

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            api.v1.selectors.groupUsages({ searchText: searchText }, { signal })
                .then(result => { 

                    const items = result.data.map(x => ({
                        key: x.value,
                        label: x.name,
                        canDelete: true,
                    })) as AutoCompleteDataModel[];

                    resolve({
                        items: items,
                        totalRows: items.length
                    });
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            label={label ?? t("Group.UsageSelector.Placeholder")}
            onGetSuggestions={getSuggestions}
            onChange={items => onChange(items as AutoCompleteDataModel[])}
        />
    );
};